import config from './config.js'

export default {

  viewparams: {"start":0,"count":20,"search":"","sort":"map_id","sdir":"desc","cid":""},

  // list orders
  list: function(cb_success) {
    var u = config.baseUrl + 'rest/delivery/?start=' + this.viewparams.start + '&count=' + this.viewparams.count + '&sort=' + this.viewparams.sort + '&sdir=' + this.viewparams.sdir;
    if (this.viewparams.search.length > 0)
      u += '&search=' + encodeURIComponent(this.viewparams.search);
    if (this.viewparams.cid.length > 0)
      u += '&cid=' + this.viewparams.cid;
    fetch(u,{credentials:'include'}).then(resp => resp.json()).then(cb_success);
  },

  load(id) {
    return fetch('/trendshop.proxy.web/rest/delivery/' + encodeURIComponent(id)).then(resp => resp.json());
  }

}
